import { SectionHead } from "./Home";
import { Sparkles, Heart, ShieldCheck, Truck } from "lucide-react";

export default function ChiSiamo() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 md:py-20">
      <SectionHead
        eyebrow="Chi siamo"
        title="Benvenuto nel mondo PULL STATION"
        subtitle="Il tuo punto di riferimento italiano per One Piece Card Game, Pokémon TCG e prodotti da collezione."
      />

      <div className="mt-10 space-y-6 text-[#D1D5DB] leading-relaxed">
        <p className="text-lg">
          <span className="text-[#C9A227] font-semibold">PULL STATION</span> nasce dalla passione
          per il Trading Card Game e dal desiderio di creare uno spazio dedicato ai collezionisti
          italiani — un posto dove il valore delle carte, l'attenzione al dettaglio e la fiducia
          verso il cliente vengono prima di tutto.
        </p>
        <p>
          Ci occupiamo di <span className="text-white font-semibold">preorder giapponesi</span>,
          <span className="text-white font-semibold"> allocazioni inglesi</span>,
          <span className="text-white font-semibold"> carte singole</span>,
          <span className="text-white font-semibold"> Pokémon sealed italiano</span> e
          <span className="text-white font-semibold"> Pokémon giapponese di importazione</span>.
          Lavoriamo direttamente con fornitori giapponesi selezionati e distributori europei ufficiali
          per garantirti prodotti autentici al 100%.
        </p>
        <p>
          Ma PULL STATION non è solo un e-commerce: è una <span className="text-[#C9A227] font-semibold">community</span>.
          Ogni drop, restock, preorder e occasione flash viene comunicato in anteprima nel nostro
          gruppo WhatsApp ufficiale. Puoi anche richiedere prodotti specifici tramite la sezione
          "Richieste Prodotti" e noi cercheremo di trovarli per te.
        </p>

        <div className="grid md:grid-cols-2 gap-4 mt-10">
          <Value icon={<Sparkles size={18} />} title="Passione TCG"
            desc="Siamo collezionisti anche noi. Trattiamo ogni carta e ogni box come se fosse la nostra." />
          <Value icon={<Heart size={18} />} title="Community first"
            desc="Il gruppo WhatsApp è il cuore di PULL STATION. Anteprime, restock, aiuto tra collezionisti." />
          <Value icon={<ShieldCheck size={18} />} title="Prodotti autentici"
            desc="Solo fornitori ufficiali giapponesi e distributori europei verificati. Zero fake, zero compromessi." />
          <Value icon={<Truck size={18} />} title="Spedizione protetta"
            desc="Imballo con bolla d'aria + toploader. Assicurazione fino a €2.500 disponibile via BRT." />
        </div>

        <div className="mt-12 border-l-2 border-[#C9A227] bg-[#C9A227]/5 pl-5 py-4">
          <div className="font-mono-ps text-[#C9A227] text-xs tracking-widest uppercase mb-2">
            Il nostro payoff
          </div>
          <p className="font-display text-2xl md:text-3xl font-extrabold text-white leading-tight">
            Trova. Acquista. Colleziona.
          </p>
          <p className="text-sm text-[#9CA3AF] mt-2">PULL STATION — Your TCG Station.</p>
        </div>
      </div>
    </div>
  );
}

const Value = ({ icon, title, desc }) => (
  <div className="border border-[#C9A227]/20 rounded-sm p-5 bg-[#0b0b0d]">
    <div className="flex items-center gap-2 text-[#C9A227]">
      {icon}
      <span className="text-xs font-mono-ps uppercase tracking-widest">{title}</span>
    </div>
    <p className="text-sm text-[#D1D5DB] mt-3">{desc}</p>
  </div>
);
